export default function FurnitureDepotTerms({ terms = [], compact = false }) {
  if (!terms.length) return null;
  return (
    <ol className={`space-y-${compact ? "2" : "3"}`} data-testid="fd-terms-list">
      {terms.map((t, i) => (
        <li key={t.title} className="text-sm text-zinc-700 leading-relaxed">
          <b className="text-[#0C2E2B]">{compact ? "" : `${i + 1}. `}{t.title}.</b> {t.body}
        </li>
      ))}
    </ol>
  );
}
